import { type FC } from 'react';
import {
  Key
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconKeyProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconKey: FC<UiIconKeyProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Key}
      {...props}
    />
  );
};